(function(){
  'use strict';
  angular
  .module('app')
  .component('reportRegisterType', {
    templateUrl: 'app/components/report_registe_type/report_registe_type.html',
    controller: ReportRegisterTypeController
  });

  ReportRegisterTypeController.$inject = ['user', '$rootScope', '$window', '_', 'globalService','$uibModal','url'];

  function ReportRegisterTypeController($user, $rootScope, $window, _,$globalService, $uibModal, $url) {
    var vm = this;
    vm.loadingRequests = false;
    
    vm.showCurrentApplication = false;
    vm.loadingData = false;
    var date = new Date();
    vm.statuses = [
      {key: 0, value: "Enviada"},
      {key: 1, value: "En Proceso"},
      {key: 2, value: "Aprobada"},
      {key: 3, value: "Conflicto de Agentes"},
      {key: 4, value: "Activa"},
      {key: 5, value: "Baja"}
    ]
    vm.companyRegisterType = [{id: 'no_info_company', name: 'No Info'}, {id: 'new_for_company', name: 'New'}, {id: 'renewal_for_company', name: 'Renewal'}];
    vm.cmsRegisterType = [{id: 'no_info_cms', name: 'No Info'}, {id: 'new_for_cms', name: 'New'}, {id: 'renewal_for_cms', name: 'Renewal'}];
    vm.agentRegisterType = [{id: 'no_info_agent', name: 'No Info'}, {id: 'new_for_agent', name: 'New'}, {id: 'renewal_for_agent', name: 'Renewal'}];
    vm.insurancePeriods = [moment().format('YYYY'), moment().add(1, 'years').format('YYYY')];

    vm.$onInit = function(){
      vm.currentUser = $user.getCurrentUser();
      vm.date_from = moment().startOf('month').format('YYYY-MM-DD')
      vm.date_to = moment().endOf('month').format('YYYY-MM-DD')
      vm.params = {token: vm.currentUser.token};
      vm.params.date_from = moment(vm.date_from).startOf('month').format('YYYY-MM-DD');
      vm.params.date_to = moment(vm.date_to).endOf('month').format('YYYY-MM-DD');
      if(vm.currentUser.user_type_id == 3){
        vm.agentSelected = vm.currentUser;
        vm.params.agent = vm.currentUser.id
      }
      $rootScope.$emit('uploadBreadCrum', {current: 'Reports Applications', before: 'Home'});
      $globalService.getAllAgents.query(function(res){
        vm.agents = res;
      })
      $globalService.companies.query().$promise.then(function name(res) {
        vm.companies = res;  
      }, function(err) {
        vm.send = false;
      })
      vm.urlReportExcel = $globalService.getUrlExcel('reports/report_register_types',vm.params);
    }

    vm.consultApplicationsAll = function(){
      vm.loadingData = true;
      vm.params.date_from = moment(vm.date_from).format('YYYY-MM-DD');
      vm.params.date_to = moment(vm.date_to).format('YYYY-MM-DD');
      vm.params.agent = _.pluck(vm.agentsSelected, 'id')
      $globalService.reportRegisterType(vm.params)
      .then(function(res){
        vm.loadingData = false;
        vm.applications = res;
        vm.calculate_total(res);
        vm.urlReportExcel = $globalService.getUrlExcel('reports/report_register_types',vm.params);
      });
    }

    vm.calculate_total = function(res){
      vm.total = _.reduce(res, function(memo, data){
        memo += data.total
        return memo;
      },0);
    }

    vm.setAgents = function() {
      console.log(vm.agentsSelected)
    }

    vm.showReason = function(data){
      swal('info', data, 'info')
    }

    // column to sort
    vm.column = 'sno';

    // sort ordering (Ascending or Descending). Set true for desending
    vm.reverse = false;

    // called on header click
    vm.sortColumn = function (col) {
      vm.column = col;
      if (vm.reverse) {
        vm.reverse = false;
        vm.reverseclass = 'arrow-up';
      } else {
        vm.reverse = true;
        vm.reverseclass = 'arrow-down';
      }
    };

    // remove and change class
    vm.sortClass = function (col) {
      if (vm.column == col) {
        if (vm.reverse) {
          return 'fa-sort-amount-asc';
        } else {
          return 'fa-sort-amount-desc';
        }
      } else {
        return 'fa-sort';
      }
    }
  }


})();
